var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHardHat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 86 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .5)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "5px"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.87 39.632c1.54 1.19 41.72 1.13 40.22 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m83.09 40.872c-0.05-2.85-2.38-5.14-5.23-5.14h-4.8c0-14.13-9.75-25.97-22.89-29.19l1.21-3.78h-16.75l1.25 3.77c-13.16 3.2-22.93 15.05-22.93 29.2h-4.94c-2.89 0-5.23 2.34-5.23 5.23v7.84c-0.27 9.87 80.28 9.96 80.44 0z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.87,
    x2: 37.66,
    y1: 6.532,
    y2: 13.482
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 50.17,
    x2: 48.49,
    y1: 6.542,
    y2: 13.202
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardHat);
export default __webpack_public_path__ + "static/media/hard-hat.02c93954.svg";
export { ForwardRef as ReactComponent };